import './App.css';
// import components
import Api from './components/api';


function App() {
  return (
    <div className="App">
      <header>
        <h1>Let's meet new people</h1>
      </header>
      <main>
        <Api />
      </main>
    </div>
  );
}

export default App;
